module.exports = __webpack_public_path__ + "static/img/logo_black.2c28b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/logo_black.png
// module id = TCwg
// module chunks = 36